import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function halalBestSellersReducer(
  state = initialState.halalBestSellers,
  action
) {
  switch (action.type) {
    case types.GET_HALAL_BEST_SELLERS_SUCCESS:
      return action.items;
    case types.GET_HALAL_BEST_SELLERS_FAILED:
      return null;
    default:
      return state;
  }
}
